export enum DocumentType {
    DenialLetter = 'Denial Letter',
    AuthorizationLetter = 'Authorization Fax',
    AdditionalInformationLetter = 'Additional Information Fax',
    NOMNC = 'NOMNC',
    Approval = 'Approval Letter',
    ExpeditedGrievance = 'Expedited Grievance Letter',
    ITDDenialNotification = 'ITD/Denial Notification',
    DenialSpanish = 'Denial Letter - Spanish',
    ApprovalSpanish = 'Approval Letter - Spanish',
    ExpeditedGrievanceSpanish = 'Expedited Grievance Letter - Spanish',
    NOMNCSpanish = 'NOMNC - Spanish',
    DENC = 'DENC',
    DENCSpanish = 'DENC - Spanish',
    P2POffer = 'P2P Offer',
    SPT = 'Service Provider Termination',
    Dismissal = 'Dismissal Letter',
    DismissalNoAor = 'Dismissal No AOR Letter',
    SNFBenefitExhaustionLetter = 'SNF Benefit Exhaustion Letter',
    ReopenedApproval = "Reopened Approval Letter",
    DecisionTimeframeExtension = "Decision Timeframe Extension" 
}
